import { render, staticRenderFns } from "./el-list.vue?vue&type=template&id=0a450dd3&scoped=true"
import script from "./el-list.vue?vue&type=script&lang=js"
export * from "./el-list.vue?vue&type=script&lang=js"
import style0 from "./el-list.vue?vue&type=style&index=0&id=0a450dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a450dd3",
  null
  
)

export default component.exports